if (!customElements.get('home-protocols')) {
  class HomeProtocols extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.hp__track');
      this.cards = Array.from(this.querySelectorAll('.hp__card'));
      this.prevBtn = this.querySelector('[data-hp-prev]');
      this.nextBtn = this.querySelector('[data-hp-next]');
      this.progressBar = this.querySelector('.hp__progress-bar');
      if (!this.track) return;

      this.boundUpdate = () => requestAnimationFrame(this.update.bind(this));
      this.track.addEventListener('scroll', this.boundUpdate, { passive: true });
      window.addEventListener('on:debounced-resize', this.boundUpdate);

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scrollByCard(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scrollByCard(1));

      this.update();
    }

    disconnectedCallback() {
      if (this.track) this.track.removeEventListener('scroll', this.boundUpdate);
      window.removeEventListener('on:debounced-resize', this.boundUpdate);
    }

    // One card + gap per click
    scrollByCard(direction) {
      if (this.cards.length < 2) return;
      const gap = this.cards[1].offsetLeft - (this.cards[0].offsetLeft + this.cards[0].offsetWidth);
      const step = this.cards[0].offsetWidth + Math.max(0, gap);
      this.track.scrollBy({ left: direction * step, behavior: 'smooth' });
    }

    update() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const scrollable = maxScroll > 2;

      // Progress bar: thumb width = visible fraction, position = scroll fraction
      if (this.progressBar) {
        const visibleFraction = this.track.clientWidth / this.track.scrollWidth;
        const scrollFraction = scrollable ? this.track.scrollLeft / maxScroll : 0;
        this.style.setProperty('--hp-progress-size', `${Math.min(1, visibleFraction) * 100}%`);
        this.style.setProperty('--hp-progress-pos', `${scrollFraction * (100 - Math.min(1, visibleFraction) * 100)}%`);
      }

      // Arrows: disable at the ends
      if (this.prevBtn) this.prevBtn.disabled = !scrollable || this.track.scrollLeft <= 2;
      if (this.nextBtn) this.nextBtn.disabled = !scrollable || this.track.scrollLeft >= maxScroll - 2;

      // Vertically center the arrows on the card image, not the whole card
      const media = this.cards[0] && this.cards[0].querySelector('.hp__media');
      if (media) this.style.setProperty('--hp-arrow-top', `${media.clientHeight / 2}px`);

      this.classList.toggle('hp--scrollable', scrollable);
    }
  }

  customElements.define('home-protocols', HomeProtocols);
}
